module.exports = __webpack_public_path__ + "static/media/LH_v02.3a689f96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LH_v02.svg
// module id = 5
// module chunks = 1